import { SkeletonLine } from '@spo/storybook';
import { SpoSmSheetResponse } from '@spo/types';
import { VpIcon } from '@vtmn-play/react';
import { format } from 'date-fns';
import genericImage from '../../assets/genericImage.jpeg';
import './smQuickInfos.scss';

export interface SmQuickInfosProps {
  sm: SpoSmSheetResponse | undefined;
  isLoading: boolean;
}

export const SmQuickInfos = ({ sm, isLoading }: SmQuickInfosProps) => {
  return (
    <div data-testid="sm-quick-infos" className="my-sm-informations">
      <img
        data-testid="sm-quick-infos_img"
        className="my-sm-img"
        src={sm?.imageURL ?? genericImage}
        alt="super model"
      />
      <div className="my-sm-details-container">
        {sm && !isLoading ? (
          <>
            <div
              className="my-sm-details-title"
              data-testid="sm-quick-infos_details-title"
            >
              <span>{sm?.descriptionEn}</span>
            </div>
            <div className="my-sm-details">
              <span
                className="my-sm-details_sm-id"
                data-testid="my-sm-details_sm-id"
              >
                {sm?.id}
              </span>
              <span data-testid="my-sm-details_user-need-id">
                {sm.userNeedLabel ?? sm?.userNeedId}
              </span>
              <span data-testid="my-sm-details_product-nature-id">
                {sm.productNatureLabel ?? sm?.productNatureId}
              </span>
              <span data-testid="my-sm-details_brand-id">
                {sm.brandLabel ?? sm?.brandId}
              </span>
              <span
                className="my-sm-details-dates"
                data-testid="my-sm-details-dates"
              >
                <VpIcon name="calendar" />
                {sm?.startDate && format(new Date(sm.startDate), 'dd/MM/yyyy')}-
                {sm?.endDate && format(new Date(sm.endDate), 'dd/MM/yyyy')}
              </span>
            </div>
          </>
        ) : (
          <>
            <SkeletonLine />
            <SkeletonLine />
          </>
        )}
      </div>
    </div>
  );
};
